import { StatusCadastroUsuarioEnum } from './../../../domain/primecap/model/enum/status-cadastro-usuario.enum';
import { Investimento } from './../../../domain/primecap/model/investimento';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AcoesCrudEnum, AcoesExtraEnum, AcoesInvestimentoEnum } from '../tabela-acoes.enum';
import { EventoAcaoCrud, EventoAcaoExtra, EventoInvestimento } from '../model/tabela-eventos.model';

@Component({
  selector: 'app-coluna-acoes-crud',
  templateUrl: './coluna-acoes-crud.component.html',
  styleUrls: ['./coluna-acoes-crud.component.css']
})
export class ColunaAcoesCrudComponent {

  // objeto que será exibido na tabela
  @Input() objeto: any;

  // indica que se trata de uma rodada de investimento
  // para exibir botão de edição somente quando status == 'STAND_BY'
  @Input() isRodadaInvestimento?: boolean = false;

  @Input() isAssessor: boolean = false;

  // ações crud a serem exibidas na tabela
  @Input() exibirEdicao?: boolean = false;
  @Input() exibirDelecao?: boolean = false;
  @Input() exibirDetalhes?: boolean = false;

  // outras ações a serem exibidas na tabela
  @Input() exibirDashboard?: boolean = false;
  @Input() exibirAbrirPagina?: boolean = false;
  @Input() exibirAtivacao?: boolean = false;
  @Input() exibirDesativacao?: boolean = false;
  @Input() exibirRecusarInvestimento?: boolean = false;
  @Input() exibirAssinarInvestimento?: boolean = false;
  @Input() exibirConfirmarPagamento?: boolean = false;
  @Input() exibirAnalisarInvestimento?: boolean = false;
  @Input() exibirEnviarBoleto?: boolean = false;

  @Input() tituloAbrirPagina?: string = 'Visualizar';
  @Input() iconeAbrirPagina?: string = 'open';

  // notifica o componente pai qual operação crud e objeto foram chamados
  @Output() readonly acaoCrud: EventEmitter<EventoAcaoCrud<any>> = new EventEmitter();

  // notifica o componente pai qual ação e objeto foram chamados
  @Output() readonly acaoExtra: EventEmitter<EventoAcaoExtra<any>> = new EventEmitter();

  // notifica o componente pai de que uma ação em um investimento foi chamada
  @Output() readonly acaoInvestimento: EventEmitter<EventoInvestimento> = new EventEmitter();

  // propriedade usada no HTML representando as ações CRUD
  readonly acoesCrud: typeof AcoesCrudEnum = AcoesCrudEnum;

  // propriedade usada no HTML representando as outras ações possíveis
  readonly acoesExtra: typeof AcoesExtraEnum = AcoesExtraEnum;

  // propriedade usada no HTML representando as ações em investimento
  readonly acoesInvestimento: typeof AcoesInvestimentoEnum = AcoesInvestimentoEnum;

  readonly statusUsuario: typeof StatusCadastroUsuarioEnum = StatusCadastroUsuarioEnum;

  constructor() { }

  // emite evento de notificação de que uma operação crud foi solicitada
  // em um objeto
  executarAcaoCrud(acaoCrud: string, objeto: any): void {
    if (!this.acaoCrud) {
      return;
    }
    this.acaoCrud.emit({ acaoCrud, objeto });
  }

  // emite evento de notificação de que uma ação foi solicitada
  // em um objeto
  executarAcaoExtra(acaoExtra: string, objeto: any): void {
    if (!this.acaoExtra) {
      return;
    }
    this.acaoExtra.emit({ acaoExtra, objeto });
  }

  // emite evento de notificação de que uma ação foi solicitada
  // em um investimento
  executarAcaoInvestimento(acaoInvestimento: string, investimento: Investimento): void {
    if (!this.acaoInvestimento) {
      return;
    }
    this.acaoInvestimento.emit({acaoInvestimento, investimento});
  }
}
